import CountryFlag from '../CountryFlag/CountryFlag';
import { OptionItemInfoText } from '../OptionItem';
import OptionItem from '../OptionItem/OptionItem';

import styles from './CountryOption.module.css';

export interface CountryOptionProps {
  className?: string;
  loading?: boolean;
  disabled?: boolean;
  countryName: string;
  countryFlagSrc: string;
  infoText?: string;
  onClick?: () => void;
}

export default function CountryOption({
  className,
  countryName,
  countryFlagSrc,
  infoText,
  ...otherProps
}: CountryOptionProps): JSX.Element {
  return (
    <OptionItem
      {...otherProps}
      name={countryName}
      icon={
        <CountryFlag
          className={styles['flag']}
          countryFlagSrc={countryFlagSrc}
          countryName={countryName}
        />
      }
      disabled={otherProps.disabled}
      rightBottomSlot={infoText && <OptionItemInfoText text={infoText} />}
    />
  );
}
